import { AUTH_PROVIDER_HEADER, AuthProviderEnum, TAuthProvider } from '@onesource/schemas';

export const SESSION_STORAGE_KEY = 'session';
export const USER_STORAGE_KEY = 'user';
export const LC_SOURCE_STORAGE_KEY = 'lc_auth_source';
export const REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';

export const getActiveAuthProvider = (): TAuthProvider => AuthProviderEnum.supabase;

export const setActiveAuthProvider = (_provider: TAuthProvider): void => {
  // no-op: auth provider is always supabase
};

export const clearAuthProvider = (): void => {
  try {
    localStorage.removeItem(SESSION_STORAGE_KEY);
    localStorage.removeItem(USER_STORAGE_KEY);
    localStorage.removeItem(LC_SOURCE_STORAGE_KEY);
    localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear auth session from localStorage:', error);
  }
};

export const removeAuthFlag = (): void => {
  // no-op: auth flag removed, provider is always supabase
};

export const isSupabaseAuthActive = (): boolean => true;

export const isWordPressAuthActive = (): boolean => false;

export const getAuthProviderHeader = (): Record<string, string> => {
  return { [AUTH_PROVIDER_HEADER]: AuthProviderEnum.supabase };
};

let _skipMembersRedirect = false;

export const setSkipMembersRedirect = (skip: boolean): void => {
  _skipMembersRedirect = skip;
};

export const redirectForSSOLogin = (_authProvider?: TAuthProvider): void => {
  const membersFeUrl = import.meta.env.VITE_MEMBERS_FE_URL as string | undefined;

  if (!_skipMembersRedirect && membersFeUrl) {
    window.location.href = membersFeUrl;
    return;
  }

  if (window.location.pathname !== '/auth/login') {
    window.location.href = '/auth/login';
  }
};

export const redirectToMembers = (_authProvider?: TAuthProvider): void => {
  const membersFeUrl = import.meta.env.VITE_MEMBERS_FE_URL as string | undefined;

  if (!_skipMembersRedirect && membersFeUrl) {
    window.location.href = `${membersFeUrl}/apps`;
    return;
  }

  if (window.location.pathname !== '/auth/login') {
    window.location.href = '/auth/login';
  }
};
